export const brandColorEndPoint = `brand-colors`;
